module.exports = __webpack_public_path__ + "static/media/goodburger-icon.ab356e9e.png";